import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as e } from "react/jsx-runtime";
import i from "styled-components";
import { TypographyTokens as t } from "@vds-tokens/typography";
import { withVDSManager as l } from "@vds-core/utilities";
import { Fonts as r } from "../../fonts/index.js";
import o from "../Typography/Typography.js";
var a = ["small", "medium", "large", "XLarge", "2XLarge"],
  n = {
    small: "h5",
    medium: "h4",
    large: "h3",
    XLarge: "h2",
    "2XLarge": "h1"
  },
  m = i(o).withConfig({
    displayName: "StyledTitle",
    componentId: "VDS__sc-f6e32a-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n"]))),
  s = function s(i) {
    var l = i.children,
      o = i.primitive,
      s = i.viewport,
      u = i.size,
      g = i.color,
      d = i.bold,
      c = i.tabIndex,
      h = i.id,
      f = i.ariaLabelledBy,
      p = i.fontSize,
      b = i.lineHeight,
      v = i.letterSpacing,
      y = i.regularWeight,
      w = i["data-testid"];
    var z;
    z = "large" === i.size && "mobile" !== i.viewport || "XLarge" === i.size || "2XLarge" === i.size ? "light" : "regular";
    var L = "mobile" === s ? "mobile" : "desktop",
      X = a.indexOf(u) > -1 ? u : "small";
    var S = v || (d || "medium" === u || "small" === u || "large" === u && "mobile" === s ? null : t.letterspacing.semiwide.value);
    var x = o || (X ? n[X] : "h5");
    return e(m, {
      fontSize: p || t.fontsize.title[function () {
        switch (X) {
          case "2XLarge":
            return "mobile" === L ? 40 : 64;
          case "XLarge":
            return "mobile" === L ? 32 : 48;
          case "large":
            return "mobile" === L ? 24 : 32;
          case "medium":
            return "mobile" === L ? 20 : 24;
          default:
            return "mobile" === L ? 16 : 20;
        }
      }()].value,
      fontWeight: d ? t.fontweight.bold.value : y ? t.fontweight[y].value : "small" === u || "medium" === u || "large" === u && "mobile" === L ? t.fontweight.regular.value : t.fontweight.light.value,
      fontFamily: r.VerizonNHGeDS,
      lineheight: b || t.lineheight.title[function () {
        switch (X) {
          case "2XLarge":
            return "mobile" === L ? 40 : 64;
          case "XLarge":
            return "mobile" === L ? 36 : 48;
          case "large":
            return "mobile" === L ? 28 : 36;
          case "medium":
            return "mobile" === L ? 24 : 28;
          default:
            return "mobile" === L ? 20 : 24;
        }
      }()].value,
      letterSpacing: S,
      primitive: x,
      color: g,
      tabIndex: c,
      "aria-hidden": c && c < 0,
      id: h,
      "aria-labelledby": f,
      "data-testid": w,
      size: u,
      $regularWeight: z,
      children: l
    });
  };
s.defaultProps = {
  viewport: "desktop",
  size: "small",
  children: null,
  color: "#000000",
  bold: !1,
  letterSpacing: null,
  lineHeight: null,
  fontSize: null
};
var u = l(s);
export { u as default };